import styled from 'styled-components';

export const MarqueeContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) => (props.clothDiaper ? '#e2efe7' : '#fff')};
  padding: 6px 0;
  margin: 10px 0 0;
`;

export const MarqueeText = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 80%);
  margin-right: 4px;
  padding: 0 6px;
  text-transform: capitalize;
`;

export const MarqueeImage = styled.img`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 2px;
  position: relative;
  top: 3px;
`;
